// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___CNGQx","balance":"balance___bLycj"};